import React, { useEffect } from 'react';
import { Accordian, PageLayout } from '~/components';
import usePatient from '~/utils/patient/hook';
import { hasLegalStatus } from '~/utils/patient/identity-access';
import { IdentityPageProvider } from '~/utils/identity/page';

import HealthcareMedicaid from './healthcare-medicaid';
import Placement from './placement';
import PublicChildrensServiceAgency from './public-childrens-services-agency';
import HealthcareOrgContacts from './healthcareOrg-contacts';

const PrimaryContacts = () => {
  const [, patient, actions] = usePatient();

  const pageSpec = {
    title: 'Primary Contacts',
    enableFullPrint: hasLegalStatus(patient),
    enableIndividualPrint: hasLegalStatus(patient),
    panels: [{
      title: "Public Children's Services Agency",
      body: <PublicChildrensServiceAgency />,
    }, {
      title: 'Placement and Court',
      body: <Placement />,
    }, {
      title: 'Healthcare / Medicaid',
      body: <HealthcareMedicaid />,
    }, {
      title: 'Healthcare Organization Contacts',
      body: <HealthcareOrgContacts />,
    }],
  };

  useEffect(() => {
    actions.audit('PrimaryContacts');
  }, []);

  return (
    <PageLayout>
      <IdentityPageProvider pageSpec={pageSpec}>
        {({
          accordianItems,
          allPanelsOpen,
          expandPanel,
          openPanel,
        }) => (
          <Accordian
            openPanel={openPanel}
            allOpen={allPanelsOpen}
            setOpenPanel={expandPanel}
            items={accordianItems}
          />
        )}
      </IdentityPageProvider>
    </PageLayout>
  );
};

export default PrimaryContacts;
